import { RESTClient } from "../utils/rest";

class Products extends RESTClient{

    async getById(id){
        console.log(id);
        return this.get(`${this.slug}/old_id/${id}`);
    }
}

const products = new Products('products');
export default products;